(function ($) {
  var video_modal = $(".modal--video");
  var team_modal = $('.modal--team');
  video_modal.on("show.bs.modal", function (event) {
    var embed_container = $(this).find(".embed-container");
    var iframe_src = embed_container.data("iframe-src");

    
    embed_container.html(decode(iframe_src));
  });

  video_modal.on("hidden.bs.modal", function (event) {
    var embed_container = $(this).find(".embed-container");
    embed_container.empty();
  });

  team_modal.on("hidden.bs.modal", function (event) {
    var iframe = $(this).find('iframe');
    console.log(iframe);
    if ( iframe ) {
      var iframeSrc = iframe.attr('src');
      iframe.attr('src', iframeSrc);
    }
  });

  function decode(text) {
      var map = {
          '&amp;': '&',
          '&#038;': "&",
          '&lt;': '<',
          '&gt;': '>',
          '&quot;': '"',
          '&#039;': "'",
          '&#8217;': "’",
          '&#8216;': "‘",
          '&#8211;': "–",
          '&#8212;': "—",
          '&#8230;': "…",
          '&#8221;': '”'
      };

      return text.replace(/\&[\w\d\#]{2,5}\;/g, function(m) { return map[m]; });
  };
})(jQuery);
